
import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import AccountSearch from '../../search/AccountSearch';

export default (props) => {
  return <FormInputTagsItem {...props} inputComponent={AccountSearch} />;
};
